export default "assets/images/icons/linkedin-e9481785.svg";